<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
      <div class="input-wrapper">
          <div class="side-wrapper edit-form-title-wrapper">
              <div class="user-icon"></div>
              <p class="input-form-title">{{'HOME.USERS_TITLE' | translate}}</p>
          </div>
  
          <div class="menu-input-wrapper">
              <div class="tab-menu">
                  <div class="tab basic-info" (click)="setActiveTab('basic-info')" [ngClass]="{'active': activetab=='basic-info'}">
                      <p>{{'HOME.USERS_BASICINFO_TABTITLE' | translate}}</p>
                  </div>
                  <div class="tab roles" (click)="setActiveTab('roles')" [ngClass]="{'active': activetab=='roles'}">
                      <p>{{'HOME.USERS_ROLES_TABTITLE' | translate}}</p>
                  </div>
                  <div class="tab additional-rights" (click)="setActiveTab('additional-rights')" [ngClass]="{'active': activetab=='additional-rights'}">
                      <p>{{'HOME.USERS_ADDITIONAL_TABTITLE' | translate}}</p>
                  </div>
  
              </div>
              <!--
              -->
              <div class="input-content">
                  <div class="basic-info" *ngIf="activetab == 'basic-info'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title"><label for="Name">{{'HOME.USERS_BASICINFO_NAME' | translate}}</label></div>
                                  <input class="form-control" type="text" name="Name" [(ngModel)]="user.Name" />
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title"><label for="Workplace">{{'HOME.USERS_BASICINFO_WORKPLACE' | translate}}</label></div>
  
                                  <input class="form-control" type="text" name="Workplace" [(ngModel)]="user.Workplace">
  
  
                              </div>
                          </div>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="Surname">{{'HOME.USERS_BASICINFO_SURNAME' | translate}}</label></div>
  
                                  <input class="form-control" type="text" name="Surname" [(ngModel)]="user.Surname">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                          </div>
                      </div>
  
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_CONTACTINFORMATION' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title"><label for="Email">{{'HOME.USERS_BASICINFO_EMAIL' | translate}}</label></div>
                                  <input class="form-control" type="text" name="Email" [(ngModel)]="user.Email">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title"><label for="PhoneNumber">{{'HOME.USERS_BASICINFO_PHONENUMBER' | translate}}</label></div>
  
                                  <input class="form-control" type="text" name="Phone" [(ngModel)]="user.Phone">
  
                              </div>
                          </div>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="Fax">{{'HOME.USERS_BASICINFO_FAX' | translate}}</label></div>
  
                                  <input class="form-control" id="Fax" name="Fax" placeholder="Fax number" type="text"
                                  [(ngModel)]="user.Fax">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="Website">{{'HOME.USERS_BASICINFO_WEBSITE' | translate}}</label></div>
  
                                  <input class="form-control" id="Website" name="Website"
                                      placeholder="Website address (www.example.com)" type="text" [(ngModel)]="user.Website">
  
                              </div>
                          </div>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="MobilneNumber">{{'HOME.USERS_BASICINFO_MOBILENUMBER' | translate}}</label></div>
                                  <input class="form-control" id="MobilneNumber" name="MobilneNumber"
                                      placeholder="Mobile phone number" type="text" [(ngModel)]="user.MobilneNumber">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
                              </div>
                          </div>
                      </div>
  
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_USERNAMEANDPASSWORD' | translate}}</p>
  
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="Username">{{'HOME.USERS_BASICINFO_USERNAME' | translate}}</label></div>
  
                                  <input class="form-control" data-val="true"
                                      data-val-required="The Username field is required." id="Username" name="Username"
                                      placeholder="User login name (A-z and 0-9)" type="text" [(ngModel)]="user.Username">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title"><label for="Password">{{'HOME.USERS_BASICINFO_PASSWORD' | translate}}</label></div>
  
                                  <input class="form-control" id="Password" name="Password"
                                      placeholder="Password (A-z and 0-9)" type="password" [(ngModel)]="user.Password">
  
                              </div>
                          </div>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
  
                                  <div class="title required"><label for="PasswordConfirm">{{'HOME.USERS_BASICINFO_PASSWORDCONFIRM' | translate}}</label></div>
  
                                  <input class="form-control" id="PasswordConfirm" name="PasswordConfirm"
                                      placeholder="Enter password confirmation (A-z and 0-9)" type="password" [(ngModel)]="user.PasswordConfirm">
  
                              </div>
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                          </div>
                      </div>
  
                  </div>
  
                  <div class="roles" *ngIf="activetab == 'roles'">
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_ROLES_TABTITLE' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">  
                                  <div class="checkbox" *ngFor="let ug of user.GroupsModel.Groups">
                                      <label>
                                          <input  type="checkbox" [(ngModel)]="ug.Selected" [ngModelOptions]="{standalone: true}"/>
                                          <span class="checkmark"></span>
                                          {{ug.Name}}
                                      </label>
                                  </div>       
                              </div>
                          </div>
                          <!--
                              -->
                          <div class="side-input-container">
                          </div>
                      </div>
                  </div>
  
                  <div class="additional-rights" *ngIf="activetab == 'additional-rights'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_ADDITIONAL_TABTITLE' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                              <div class="input-control">
                                  <table class="table table-hover">
                                      <tbody>
                                          <tr>
                                              <th>{{'HOME.USERS_ADDITIONAL_RIGHT' | translate}}</th>
                                              <th style="width:50px; text-align:center;"><a class="checkAll"
                                                      data-chbclass="group-allow"
                                                      data-chbclassreset="group-deny">{{'HOME.USERS_ADDITIONAL_ALLOW' | translate}}</a></th>
                                              <th style="width:50px; text-align:center;"><a class="checkAll"
                                                      data-chbclass="group-deny" data-chbclassreset="group-allow">{{'HOME.USERS_ADDITIONAL_DENY' | translate}}</a>
                                              </th>
                                          </tr>
  
                                          <tr *ngFor="let ri of user.RightsFormModel.Rights">
                                              <td>
                                                  <p>{{ri.Description}}</p>
                                              </td>
                                              <td style="width:50px; text-align:center;">
                                                  <div class="checkbox">
                                                      <label>
                                                          <input type="checkbox" [(ngModel)]="ri.AllowSelected" [ngModelOptions]="{standalone: true}"/>
                                                          <span class="checkmark"></span>
                                                      </label>
                                                  </div>
                                              </td>
                                              <td style="width:50px; text-align:center;">
                                                  <div class="checkbox">
                                                      <label>
                                                          <input type="checkbox" [(ngModel)]="ri.DenySelected" [ngModelOptions]="{standalone: true}"/>
                                                          <span class="checkmark"></span>
                                                      </label>
                                                  </div>
                                              </td>
                                          </tr>
  
                                      
  
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          <!--
                              -->
                          <div class="side-input-container">
                          </div>
                      </div>
                  </div>
  
              </div>
          </div>
  
      </div>
  </form>
  </div>